/*
 *
 * Copyright (C) 2022 NetBase Solutions, Inc.
 * 3960 Freedom Circle Suite 201 Santa Clara, CA 95054
 * All rights reserved.
 */

import React from 'react'

import { WidgetGuard } from 'features/types'
import { useDashboardWidgetSetting } from 'hooks/useDashboardState'
import { ComparisonMode } from 'enums'
import { SocialWebTimelineComparisonWidget } from 'schemas/SocialWebTimelineComparisonWidgetSchema'
import { TopicNotSelectedGuard } from '../../../../share/guards'
import TagsMatrixedItemCountGuard from '../../../share/ComparisonMode/guards/TagsMatrixedItemCountGuard'
import ThemesMatrixedItemCountGuard from '../../../share/ComparisonMode/guards/ThemesMatrixedItemCountGuard'
import ProductHierarchyMatrixedItemCountGuard from '../../../share/ComparisonMode/guards/ProductHierarchyMatrixedItemCountGuard'

const ComparisonModeWidgetSettingGuards: WidgetGuard = ({ widgetId, children }) => {
  const { comparisonMode } = useDashboardWidgetSetting<SocialWebTimelineComparisonWidget>(widgetId)

  return (
    <TopicNotSelectedGuard widgetId={widgetId}>
      <>
        {comparisonMode === ComparisonMode.THEMES && (
          <ThemesMatrixedItemCountGuard widgetId={widgetId}>
            {children}
          </ThemesMatrixedItemCountGuard>
        )}
        {comparisonMode === ComparisonMode.TAGS && (
          <TagsMatrixedItemCountGuard widgetId={widgetId}>{children}</TagsMatrixedItemCountGuard>
        )}
        {comparisonMode === ComparisonMode.DOC_HIERARCHIES && (
          <ProductHierarchyMatrixedItemCountGuard widgetId={widgetId}>
            {children}
          </ProductHierarchyMatrixedItemCountGuard>
        )}
      </>
    </TopicNotSelectedGuard>
  )
}

export default ComparisonModeWidgetSettingGuards
